import { fetcher } from "utils";

import { GetMembersIssuedDiscountCouponsPossibleCouponsResponse } from "typings";

export const get__members__issued_discount_coupons__possible_coupons = (params: {
  productOptionIds: number[];
}): Promise<GetMembersIssuedDiscountCouponsPossibleCouponsResponse> =>
  fetcher.get("/members/issued_discount_coupons/possible_coupons", params);
